/* eslint-disable react/prop-types */
import { useState } from 'react';
// @mui
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Table,
  TableRow,
  TableBody,
  Button,
  TableCell,
  Typography,
  TableContainer,
  Pagination,
} from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
// components
import CycloneIcon from '@mui/icons-material/Cyclone';
import { toast } from 'react-toastify';

import Scrollbar from '../../../../components/scrollbar';

// sections
import ClientHeadTable from '../../../../components/clientHeadTable/ClientHeadTable';
import { ReactComponent as EditIcon } from '../../../../theme/images/editTableIcon.svg';
import { ReactComponent as ShowIcon } from '../../../../theme/images/showTableIcon.svg';
import { cloneUnit } from '../../../../network/apis';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function ClientReqTable({
  requests,
  handleChangePage,
  page,
  onDelete,
  hasEditPermission,
  hasAddPermission,
  purposesList = [],
}) {
  const [rowsPerPage] = useState(1);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  const handleClone = async (id) => {
    const response = await cloneUnit(id);
    if (response?.data?.STATUS === 'SUCCESS') {
      navigate(`/dashboard/units/edit/${response?.data?.ID}`, { state: { isClone: true } });
    } else {
      toast.error(response?.data?.MESSAGE);
    }
  };
  const TABLE_HEAD = [
    { id: 'projectName', label: t('ManageProject.projectName'), alignRight: isRtl && true },
    { id: 'listingType', label: t('General.listingTypeUnit'), alignRight: isRtl && true },
    { id: 'NAME_EN', label: t('General.name'), alignRight: isRtl && true },
    { id: 'type', label: t('General.type'), alignRight: isRtl && true },
    { id: 'reservation_status', label: t('General.Status'), alignRight: isRtl && true },
    { id: 'purpose', label: t('General.purpose'), alignRight: isRtl && true },
    { id: 'creation_date', label: t('General.creationDate'), alignRight: isRtl && true },
    { id: 'action', label: t('General.Action'), alignRight: isRtl && true },
  ];
  return (
    <>
      <Scrollbar>
        <TableContainer component={Paper} sx={{ minWidth: 800 }}>
          <Table sx={{ direction: isRtl ? 'rtl' : 'ltr' }}>
            <ClientHeadTable t={t} isRtl={isRtl} headLabel={TABLE_HEAD} />
            <TableBody>
              {requests?.content?.map((row) => {
                const { id, nameEn, nameAr, creationDate, project, pieceStatus, reservationStatus, purpose, type, unitType } =
                  row;
                const displayDate = creationDate
                  ? new Date(creationDate).toLocaleDateString()
                  : new Date().toLocaleDateString();

                const currentListingType = row.listingType || 'SALE';


                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {isRtl ? project.nameAr : project.nameEn}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '4px 16px',
                          backgroundColor: currentListingType === 'RENT' ? '#E3F2FD' : '#E7F7EF',
                          borderRadius: '8px',
                          width: '100px',
                        }}
                      >
                        <Typography
                          sx={{
                            color: currentListingType === 'RENT' ? '#1976D2' : '#0CAF60',
                            fontWeight: '700',
                            fontSize: '10px',
                            lineHeight: '16px',
                          }}
                          variant="subtitle2"
                          textAlign={'center'}
                          noWrap
                        >
                          {currentListingType === 'RENT' ? t('reversationRequest.rent') : t('reversationRequest.sale')}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {isRtl ? nameAr : nameEn}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {unitType?.name}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      {reservationStatus === 'FREE' ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 16px',
                            backgroundColor: '#E7F7EF',
                            borderRadius: '8px',
                            width: '88px',
                          }}
                        >
                          <Typography
                            sx={{ color: '#0CAF60', fontWeight: '700', fontSize: '10px', lineHeight: '16px' }}
                            variant="subtitle2"
                            textAlign={'center'}
                            noWrap
                          >
                            {t('Units.available')}
                          </Typography>
                        </Box>
                      ) : reservationStatus === 'RESERVED' ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 16px',
                            backgroundColor: '#f3c5105c',
                            borderRadius: '8px',
                            width: '88px',
                          }}
                        >
                          <Typography
                            sx={{ color: '#907200', fontWeight: '700', fontSize: '10px', lineHeight: '16px' }}
                            variant="subtitle2"
                            textAlign={'center'}
                            noWrap
                          >
                            {t('Units.reserved')}
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 16px',
                            backgroundColor: '#FFEDEC',
                            borderRadius: '8px',
                            width: '88px',
                          }}
                        >
                          <Typography
                            sx={{ color: '#E03137', fontWeight: '700', fontSize: '10px', lineHeight: '16px' }}
                            variant="subtitle2"
                            textAlign={'center'}
                            noWrap
                          >
                            {t('Units.sold')}
                          </Typography>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {(() => {
                          const matchedPurpose = purposesList?.find((p) => p.value === purpose);
                          return matchedPurpose ? (isRtl ? matchedPurpose.labelAr : matchedPurpose.labelEn) : (purpose || '');
                        })()}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {displayDate || ''}
                      </Typography>
                    </TableCell>

                    {hasEditPermission && (
                      <TableCell align="left">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                          <Button
                            onClick={() =>
                              navigate(`/dashboard/units/view/${id}`, {
                                state: { editData: row },
                              })
                            }
                          >
                            <ShowIcon />
                          </Button>{' '}
                          <Button
                            onClick={() =>
                              navigate(id ? `/dashboard/units/edit/${id}` : '/dashboard/units/add', {
                                state: { editData: row },
                              })
                            }
                          >
                            <EditIcon />
                          </Button>
                          {(hasAddPermission || hasEditPermission) && (
                            <Button onClick={() => handleClone(id)}>
                              <CycloneIcon />
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
      {requests?.totalElements === 0 && (
        <Box textAlign="center">
          <h5>{t('General.noDataFound')}</h5>
        </Box>
      )}
      {requests?.totalPages > 0 && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px',
            marginTop: '5rem',
          }}
        >
          <Pagination count={requests.totalPages} page={page + 1} onChange={handleChangePage} color="primary" />
          <Box sx={{ display: 'block' }}>
            {t('General.showing')} {page * rowsPerPage + 1} {t('General.of')}{' '}
            {Math.min((page + 1) * rowsPerPage, requests.totalElements)} {t('General.to')} {requests.totalElements}{' '}
            {t('General.entries')}
          </Box>
        </Box>
      )}
      {/* {requests?.totalPages > 0 && (
        <TablePagination
          rowsPerPageOptions={[9]}
          component="div"
          count={requests.totalPages}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )} */}
    </>
  );
}
